const asArray = value => (Array.isArray(value) ? value : []);

export const hasNestedSubsets = node => asArray(node?.subsets).length > 0;

export const countSubsetNestings = node => asArray(node?.subsets).reduce((total, child) => total + 1 + countSubsetNestings(child), 0);

export const withSubsetRecordIds = (nodes, parameterType, prefix = 'subset') =>
    asArray(nodes).map((node, index) => {
        const id = `${prefix}-${index}`;

        return {
            ...node,
            id,
            parameterType,
            subsets: withSubsetRecordIds(node?.subsets, parameterType, id),
        };
    });
